module.exports = __webpack_public_path__ + "img/22.663e8a94.svg";